<template>
    <div class="white-box text-center">
        <h2 class="light-green">Contáctanos</h2>
        <div class="row text-lg-start text-center">
            <div class="col-lg-5 col-12 pe-lg-5">
                <div class="d-flex pt-4">
                <p class="p-21 uppercase">Números de teléfono</p>
                <a href="tel: 56227529068" class="p-18" target="_blank">(+56 2) 2752 9068</a>
                <a href="tel: 56227529070" class="p-18" target="_blank">(+56 2) 2752 9070</a>
                <a href="tel: 56227529071" class="p-18" target="_blank">(+56 2) 2752 9071</a>
                </div>
                <div class="d-flex py-5">
                <p class="p-21 uppercase">Correo electrónico</p>
                <a href="mailto: esami@esami.cl" class="p-18" target="_blank">esami@esami.cl</a>
                <a href="mailto: ventas@esami.cl" class="p-18" target="_blank">ventas@esami.cl</a>
                </div>
                <div class="d-flex pb-5 px-lg-0 px-4">
                <p class="p-21 uppercase">Dirección</p>
                <a href="https://maps.app.goo.gl/UtpvxM52frQkrMqn9" class="p-18" target="_blank">Diagonal Oriente 1835, Ñuñoa, Santiago - Chile</a>
                </div>
            </div>
            <div class="col-lg-7 col-12">
                <iframe 
                data-tally-src="https://tally.so/embed/w8vp4P?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" 
                loading="lazy" 
                width="100%" 
                height="400" 
                frameborder="0" 
                marginheight="0" 
                marginwidth="0" 
                title="Formulario Web">
                </iframe>
            </div>  
        </div>
    </div>
</template>

<script>

export default {
    name: 'ContactBox',
    mounted(){
    // Tally se carga solo cuando el formulario se acerca a la pantalla, para no frenar la carga inicial
    if (window.Tally) {
      window.Tally.loadEmbeds();
      return
    }
    if (!('IntersectionObserver' in window)) return this.loadTally()
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) {
        this.observer.disconnect()
        this.loadTally()
      }
    }, { rootMargin: '600px' })
    this.observer.observe(this.$el)
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    loadTally() {
      let script = document.querySelector('script[src="https://tally.so/widgets/embed.js"]')
      if (!script) {
        script = document.createElement('script')
        script.src = 'https://tally.so/widgets/embed.js'
        script.async = true
        document.body.appendChild(script)
      }
      script.addEventListener('load', () => window.Tally && window.Tally.loadEmbeds())
    }
  },

}
</script>